import React, {Component} from 'react'
import {Container}        from "semantic-ui-react"
import shop               from "shop/shop"
import WordPress          from "../WordPress"

import "./CmsPage.css"
import { SEOPage }        from "../components/SEO";

export default class CmsPage extends Component {
	constructor( props ) {
		let {params} = props.match
		console.log( `params`, props )
		super()
		this.state = {
			slug: params.slug,
			page: {}
		}
		this.load( this.state.slug )

		this.checkCodeLogin();
	}

	checkCodeLogin() {
		// check for landing page login
		const query = new URLSearchParams(window.location.search)
		console.log('start wp page with key login test');
		if (query.has('account')) {
			var key = query.get('account');
			fetch('/shop/rest/security/keylogin',{ headers: {"con-api-key":key } }).then(resp => resp.json()).then(function(data) {
				shop.whoami();
			});
		}		
	}

	componentDidUpdate() {
		const slug = this.props.match.params.slug
		if ( this._currentSlug !== slug ) {
			this._currentSlug = slug
			this.load( slug )
		}
	}

	load( slug ) {
		console.log( `loading::cms::slug", ${slug}` )
		shop.page( slug ).then( page => {
			this.setState( {page} )
			console.log( `page::loaded`, page )
		} )
	}

	render() {
		let {page} = this.state
		return (
			<div className="cms-page">
				{page && <SEOPage page={page}/>}
				<WordPress page={page} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/CmsPage.js